document.addEventListener("DOMContentLoaded", () => {
	const hashUrl = window.location.hash;
	const $arrTabsBtn = Array.from(document.querySelectorAll(".hash-toggle[data-bs-target]"));
	const $tabNowBtn = hashUrl && document.querySelector(`[data-bs-target="${hashUrl}"]`);

	$arrTabsBtn.forEach((btn) => btn.addEventListener("click", () => window.location.hash = btn.dataset.bsTarget));

	if ($tabNowBtn) return $tabNowBtn.click();
});
